// src/data/galleryData.js

// This data powers the galleries linked from the Booking Packages.
// It's separate from pastShows.js, which is for specific, dated events.
const galleryData = {
  "solo-acoustic": {
    slug: "solo-acoustic",
    venue: "Solo Acoustic Showcases",
    city: "Various Locations",
    date: "Photo Collection",
    packageType: "Solo Acoustic Performance",
    images: [
      "/assets/images/placeholder-gallery-1.jpg",
      "/assets/images/placeholder-gallery-2.jpg",
      "/assets/images/placeholder-gallery-3.jpg",
      "/assets/images/placeholder-gallery-4.jpg",
      "/assets/images/placeholder-gallery-5.jpg",
      "/assets/images/placeholder-gallery-6.jpg",
    ],
  },
  "full-band-party": {
    slug: "full-band-party",
    venue: "Full Band Private Parties",
    city: "Various Locations",
    date: "Photo Collection",
    packageType: "Full Band Experience",
    images: [
      "/assets/images/placeholder-gallery-1.jpg",
      "/assets/images/placeholder-gallery-2.jpg",
      "/assets/images/placeholder-gallery-3.jpg",
      "/assets/images/placeholder-gallery-4.jpg",
      "/assets/images/placeholder-gallery-5.jpg",
      "/assets/images/placeholder-gallery-6.jpg",
    ],
  },
  "weddings-special": {
    slug: "weddings-special",
    venue: "Weddings & Quinceañeras",
    city: "Various Locations",
    date: "Photo Collection",
    packageType: "Wedding & Special Events",
    images: [
      "/assets/images/placeholder-gallery-1.jpg",
      "/assets/images/placeholder-gallery-2.jpg",
      "/assets/images/placeholder-gallery-3.jpg",
      "/assets/images/placeholder-gallery-4.jpg",
      "/assets/images/placeholder-gallery-5.jpg",
      "/assets/images/placeholder-gallery-6.jpg",
    ],
  },
  "venue-concerts": {
    slug: "venue-concerts",
    venue: "Venue & Concert Performances",
    city: "Various Theaters & Clubs",
    date: "Photo Collection",
    packageType: "Public Concerts",
    images: [
      "/assets/images/placeholder-gallery-1.jpg",
      "/assets/images/placeholder-gallery-2.jpg",
      "/assets/images/placeholder-gallery-3.jpg",
      "/assets/images/placeholder-gallery-4.jpg",
      "/assets/images/placeholder-gallery-5.jpg",
      "/assets/images/placeholder-gallery-6.jpg",
    ],
  },
};

export default galleryData;
